import React from 'react'
import { Field, getFormValues, change } from 'redux-form'
import { connect } from 'react-redux'

import { StdCard } from 'components'
import FieldInput, { InputType as type } from 'components/SemanticForm'

import { FieldRow } from '../styled'
import r from 'reactotron-react-js'

const TypeOfContract = (props) => {
  const {
    valueForm,
    optionContract,
    optionTypeOfContract,
    // props
    isEdit = false,
    isCreate = false,
    isDetail = false,
  } = props

  React.useEffect(()=>{
    if(valueForm&&valueForm.requestContract){
      if(['C1','C2'].findIndex(x=>x==valueForm.requestContract)>=0){
        props.change('formContract','mainContract',true)
      }else{
        props.change('formContract','mainContract',false)
      }
    }
  },[valueForm&&valueForm.requestContract])

  const setContractrequestContract = () =>{
    if(isDetail){
      return optionContract.data
    }else{
      if(valueForm&&'C3C4'.includes(valueForm.requestContract)){
        return optionContract.data
      }else{
        return optionContract.data.filter(x=>!'C3C4'.includes(x.value))
      }
    }
  }

  return (
    <StdCard title='Type of Contract' style={{ marginTop: '10px' }}>
      <FieldRow>
        <Field
          name="contractLanguage"
          label="Contract Language"
          type={type.radio}
          options={[
            { text: 'Thai', value: 'Thai' },
            { text: 'Eng', value: 'Eng' }]}
          component={FieldInput}
          editable={!isDetail}
          horizontalView
          require={!isDetail}
        />
        <Field
          name="mainContract"
          label="Main Contract"
          fieldInputStyle={{justifyContent:'center'}}
          type={type.checkbox}
          component={FieldInput}
          editable={false}
        />
      </FieldRow>
      <FieldRow>
        <Field 
          name='requestContract' 
          label='Contract'
          type={type.select}
          component={FieldInput}
          editable={!isDetail&&(valueForm&&!'C3C4'.includes(valueForm.requestContract||'null'))}
          options={setContractrequestContract()}
          loading={optionContract.loading}
          require
        />
        <Field 
          name='typeOfContract' 
          label='Type Of Contract'
          type={type.multiSelect}
          component={FieldInput}
          editable={!isDetail}
          options={optionTypeOfContract.data}
          loading={optionTypeOfContract.loading}
          require
        />
      </FieldRow>
      {valueForm&&valueForm.typeOfContract&&valueForm.typeOfContract.find(x=>x.toLowerCase()=='tc06')&&
      <FieldRow>
        <div style={{flex:1,marginRight:'1rem'}}/>
        <Field 
          name='typeOfContractOther' 
          label='Type Of Contract Other'
          type={type.text}
          component={FieldInput}
          editable={!isDetail}
          require
        />
      </FieldRow>}
    </StdCard>
  )
}
const mapStateToProps = (state, props) => {
  return ({
    optionContract:state.contract.optionContract,
    optionTypeOfContract:state.contract.optionTypeOfContract,
    valueForm: getFormValues('formContract')(state),
  })
}

const mapDispatchToProps = {
  change
}


export default connect(mapStateToProps, mapDispatchToProps)(TypeOfContract)